import { trackEvent } from "~/hooks/useTrackingService"

/**
 * Opens a product page either in the current tab or a new tab
 * @param productId - The ID of the product to open
 * @param variantIds - Array of variant IDs to show. Pass empty array to show all variants
 * @param router - Router instance for navigation
 * @param newTab - Whether to open in a new tab. Defaults to false
 *
 * @example
 * // Open product in current tab showing all variants
 * openProduct("123", [], router)
 *
 * @example
 * // Open specific variants in new tab
 * openProduct("123", ["black", "white"], router, true)
 */
export const openProduct = (
  productId: string,
  variantIds: string[],
  router: any,
  newTab: boolean = false,
  path: string = "/product/$productId/overview", // Pass "." to stay on current path but update the search params
) => {
  trackEvent("Product Opened", { Product: productId })

  if (newTab) {
    const href = router.buildLocation({
      to: path,
      params: { productId },
      search: { variantIds: variantIds.length === 0 ? undefined : variantIds },
    }).href
    openInNewTab(href)
  } else {
    router.navigate({
      to: path,
      params: { productId },
      search: { variantIds: variantIds.length === 0 ? undefined : variantIds },
    })
  }
}

export const openInNewTab = (url: string) => {
  const win = window.open(url, "_blank")
  win?.focus()
}
